import React, { useEffect } from 'react';
import { Form, Col, Row, Card, Switch } from 'antd';
import Title from 'antd/lib/typography/Title';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import ModalSFS from '../../../../../../../components/theme_components/ModalSFS';
import { useForm } from 'antd/lib/form/Form';
// import IntermarqueModal from './IntermarqueModal';
import IPen from 'icons/IPen';
import IBasket from 'icons/IBasket';
import SiloList from '../SiloList';
import TaskSButtonSFS from 'pages/workflow/workflowSFS/TasksButtonSFS';
import { toCurrency } from 'utils/utils';

export type IntermarqueCardProps = {
  siloInter: any;
  tpid: number;
  refetch: () => void;
  index?: number;
  hideDeletebtn: boolean;
  action?: string;
};

const IntermarqueCard = ({
  siloInter,
  tpid,
  refetch,
  index,
  hideDeletebtn,
}: IntermarqueCardProps) => {
  const [form] = useForm();

  console.log('siloInter', siloInter)
  return (
    <Form form={form} className='ut-form-silos'>
      <Card className="activity-card mb-2">
        <Row gutter={10} >
          <Col span={3}>
            <Title level={4} className=" mb-0">
              {siloInter?.silolabel}
            </Title>
          </Col>
          <Col span={10} className='align-self-center'>
            <Title level={4} className="font-size-15 font-weight-500 mb-0">
              {siloInter?.exclusionsAuthList?.map((exclu: any) => {
                return (<p style={{ float: 'left', marginRight: '10px' }}>
                  <span>{exclu.tpname + ' '}</span> <span>{'(' + exclu.tpmainadrcity + ' ) '}</span> {index != siloInter?.exclusionsAuthList?.length - 1 && ' - '}
                </p>)
              })}
            </Title>
          </Col>



          <Col span={3}>
            {toCurrency(siloInter?.siloavailbleamount)}
          </Col>


          <Col span={3}>
            {toCurrency(siloInter?.siloavailbleamountmpea)}
          </Col>

          <Col span={2} />

          <Col span={3}>
            {' '}

            <Row justify="end">
              <Col>
                <TaskSButtonSFS
                  clientName=""
                  entityId={tpid}
                  entityReference=""
                  entityName="THIRDPARTY"
                  currcode=""
                  funcode="evupdatesilointer"
                  wizardsteps
                  // refetch={() => refetch()}
                  width={1000}
                  title="evupdatesilointer"
                  refetch={() => {
                    refetch()

                  }}
                  prcodeProps={siloInter.siloprcode}
                  dataInput={siloInter}
                >
                  <IPen
                    className=" font-size-25 "
                    style={{ cursor: "pointer" }}
                  />
                </TaskSButtonSFS>

              </Col>
              <Col>

                <TaskSButtonSFS
                  clientName=""
                  entityId={tpid}
                  entityReference=""
                  entityName="THIRDPARTY"
                  currcode=""
                  funcode="evdeletesilointer"
                  wizardsteps
                  // refetch={() => refetch()}
                  width={600}
                  title="evdeletesilointer"
                  refetch={() => {
                    refetch()
                  }}
                  dataInput={siloInter}
                >

                  <IBasket className="color-red font-size-25"
                    style={{
                      cursor: "pointer",
                      marginLeft: "42px",
                      marginRight: "13px"
                    }}
                  />
                </TaskSButtonSFS>


              </Col>
            </Row>








          </Col>
        </Row>
      </Card>
    </Form>
  );
};

export default IntermarqueCard;
